import {
  Box,
  IconArrowDropDown,
  theme,
  Typography,
  Dropdown,
  DropdownToggle,
  DropdownList,
  DropdownItem,
  IconTime,
  IconCancel,
  IconDeleteOutline,
} from '@capitalise/ui-design-system';
import { createDataTestId } from '@capitalise/utils';
import { FundingMatchStatus } from 'enums/funding-match-status';
import { UserType } from 'enums/user-type';
import { useAuthContext } from 'HOC/withAuth';
import useMediaQuery from 'modules/Business/hooks/useMediaQuery';
import PropTypes from 'prop-types';

export const options = Object.freeze({
  REMOVE_LENDER: 'removeLender',
  CANCEL_APPLICATION: 'cancelApplication',
  AWAIT_DECISION: 'awaitingDecision',
  DECLINE_OFFER: 'declineOffer',
  CONTINUE_WITH_OFFER: 'continueWithOffer',
  FAILED_LENDER: 'failed',
});

const removeLenderStatuses = [
  FundingMatchStatus.submitted,
  FundingMatchStatus.inReview,
  FundingMatchStatus.lenderRejected,
  FundingMatchStatus.incomplete,
  FundingMatchStatus.contactMade,
  FundingMatchStatus.indicativeOffer,
  FundingMatchStatus.underwrittenOffer,
  FundingMatchStatus.lenderRejected,
  FundingMatchStatus.professionsInstructed,
  FundingMatchStatus.professionsSignOff,
  FundingMatchStatus.finalCreditSignOff,
  FundingMatchStatus.lenderDecline,
];

const awaitDecisionDeclineOfferStatuses = [
  FundingMatchStatus.indicativeOffer,
  FundingMatchStatus.underwrittenOffer,
];

const ProductOptionsDropdown = ({ status, onSelect }) => {
  const { user } = useAuthContext();
  const { isMobile } = useMediaQuery();

  const isIntroducer = user.userType === UserType.introducer;

  const showAwaitingClientDecision =
    isIntroducer && awaitDecisionDeclineOfferStatuses.includes(status);

  const showDeclineOffer = awaitDecisionDeclineOfferStatuses.includes(status);

  const showRemoveLender = removeLenderStatuses.includes(status);

  if (!showAwaitingClientDecision && !showDeclineOffer && !showRemoveLender) {
    return null;
  }

  return (
    <>
      {!isMobile && <Box display="flex"></Box>}

      <Dropdown closeOnClick>
        <DropdownToggle aria-label="Open matches actions">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            backgroundColor="grey-50"
            borderRadius={theme.sizes['xtiny']}
            padding="xtiny"
          >
            <IconArrowDropDown />
          </Box>
        </DropdownToggle>
        <DropdownList>
          {showAwaitingClientDecision && (
            <DropdownItem
              leftComponent={<IconTime />}
              onClick={() => onSelect(options.AWAIT_DECISION)}
              {...createDataTestId('button', 'awaiting-client-decision')}
            >
              <Typography size="body-14">Awaiting client decision</Typography>
            </DropdownItem>
          )}
          {showDeclineOffer && (
            <DropdownItem
              leftComponent={<IconDeleteOutline />}
              onClick={() => onSelect(options.DECLINE_OFFER)}
              {...createDataTestId('button', 'decline-offer')}
            >
              <Typography size="body-14">Decline this offer</Typography>
            </DropdownItem>
          )}
          {showRemoveLender && (
            <DropdownItem
              leftComponent={<IconCancel />}
              onClick={() => onSelect(options.REMOVE_LENDER)}
              {...createDataTestId('button', 'remove-lender')}
            >
              <Typography size="body-14">Remove lender</Typography>
            </DropdownItem>
          )}
        </DropdownList>
      </Dropdown>
    </>
  );
};

ProductOptionsDropdown.propTypes = {
  status: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default ProductOptionsDropdown;
